export default __webpack_public_path__ + "static/media/journeytray-bluetree-fruit.c92952af.svg";